import { LoadState } from "../../../constants/enums";

export interface IAccountingCreditCardState {
  list: ICreditCard[];
  listLoading: LoadState;
  data: ICreditCard;
  loading: LoadState;
  error: string | null;
}

export interface ICreditCard {
  accn_credit_id: number;
  credit_id: number | null;
  account_name: string | null;
  bank_name: string | null;
  card: string | null;
  card_type: string | null;
  description: string | null;
  status: string;
}

export const INITIAL_CREDIT_CARD: ICreditCard = {
  accn_credit_id: 0,
  credit_id: null,
  account_name: null,
  bank_name: null,
  card: null,
  card_type: null,
  description: null,
  status: "ACTIVE",
};
export const initialAccountingCreditCardState: IAccountingCreditCardState = {
  list: [],
  listLoading: LoadState.NotLoaded,
  data: INITIAL_CREDIT_CARD,
  loading: LoadState.NotLoaded,
  error: null,
};
